export default __webpack_public_path__ + "static/media/IPFX.742d2eb0.svg";